import Vue from 'vue'
import Router from 'vue-router'
import Root from '@/components/Root'
import Login from '@/components/Login'
import Serial from '@/components/Serial'

Vue.use(Router)

export default new Router({
  routes: [
    {
      // ホーム画面
      path: '/',
      name: 'Root',
      component: Root
    },
    {
      // ログイン画面
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      // シリアル入力画面
      path: '/activate',
      name: 'Serial',
      component: Serial
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js